import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `DialogRoot`,
  mainRoot: `DialogMainRoot`,
  contentRoot: `DialogContentRoot`,
  content: `DialogContent`
};

export function useDialogStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          width: `100%`,
          height: `100%`,
          paddingTop: `20px`,
          overflow: `hidden`
        }
      ],
      mainRoot: [
        classNames.mainRoot,
        {
          width: `100%`,
          overflow: `hidden`
        }
      ],
      contentRoot: [
        classNames.contentRoot,
        {
          overflow: `hidden`
        }
      ],
      content: [
        classNames.content,
        {
          height: `100%`,
          overflow: `hidden`,
          paddingLeft: `15px`
        }
      ]
    }),
    []
  );
}
